export enum ExportType {
	CSV = 'CSV',
	XLSX = 'XLSX',
	API = 'API'
}
